import { render } from "./DropdownWilayah.vue?vue&type=template&id=37f47481"
import script from "./DropdownWilayah.vue?vue&type=script&lang=js"
export * from "./DropdownWilayah.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__